/* eslint global-require: 0 */
import forIn from 'lodash/forIn';
import * as types from '../../constants/ActionTypes';

function logoutRequest() {
  return {
    type: types.LOGOUT_REQUEST,
    isFetching: true,
  };
}

export function logoutFailure(error) {
  return {
    type: types.LOGOUT_FAILURE,
    error,
  };
}

export function logoutSuccess() {
  return {
    type: types.LOGOUT_SUCCESS,
  };
}

export default function logoutUser() {
  return (dispatch) => {
    dispatch(logoutRequest());
    const { language, appraisals, localSettings } = localStorage;
    let appraisalsJSON = null;
    localStorage.clear();
    // When we log out we check if we need to clear some old appraisal data
    if (appraisals && appraisals !== 'undefined') {
      appraisalsJSON = JSON.parse(appraisals);
      forIn(appraisalsJSON, ({ expires }, key) => {
        if (expires < Date.now()) {
          appraisalsJSON[key] = '';
        }
      });
      localStorage.appraisals = appraisalsJSON ? JSON.stringify(appraisalsJSON) : appraisals;
      localStorage.localSettings = localSettings;
    } else {
      localStorage.removeItem('appraisals');
    }
    localStorage.language = language;
    dispatch(logoutSuccess());
  };
}



// WEBPACK FOOTER //
// ./src/actions/account/logout.js